import Icon from "./Icon";
import * as React from "react";
import { Image } from "react-bootstrap";
import { pathToFileURL } from "url";
import { IconButton } from "./TooltipControls";
const ToolIcon = (props) => {
    const validClass = props.valid ? "valid" : "invalid";
    let iconImage;
    if (props.imageUrl !== undefined) {
        let src = pathToFileURL(props.imageUrl).href;
        if (props.imageId !== undefined) {
            src += "?" + props.imageId;
        }
        iconImage = React.createElement(Image, { src: src, className: "tool-icon " + validClass });
    }
    else {
        iconImage = (React.createElement(Icon, { name: "executable", className: "tool-icon " + validClass }));
    }
    const classes = props.classes ?? [];
    const containerClasses = props.isPrimary
        ? ["starter-tool-icon-container", "primary", ...classes]
        : ["starter-tool-icon-container", ...classes];
    return (React.createElement("div", { className: containerClasses.join(" ") },
        iconImage,
        props.isPrimary ? React.createElement("div", { className: "primary-star" }, "\u2605") : null,
        props.valid && props.t ? (React.createElement(IconButton, { icon: "launch-simple", tooltip: props.item.name, onClick: props.onRun, className: "run-tool" })) : null,
        props.children));
};
export default ToolIcon;
